import { FC, PropsWithChildren } from 'react';

export const TBody: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  return <tbody className={className}>{children}</tbody>;
};
